<template>
<div>
    <div class="row d-flex align-items-center justify-content-center">
        <div class="col-12">
            <Button @click="$router.push('/buyers')" size="small" type="outline" color="grey">
                <ArrowDropdown :rotate="90" /> Voltar
            </Button>
        </div>
        <div class="col-12 my-4">
            <h3 class="c-ndarkthree">
                <span class="bold">Regras por cedente</span> | {{economicGroup.name}}
            </h3>
        </div>
        <div class="col-12 row align-items-center justify-content-between">
            <TabModelOfferProvider class="col-6" @tabSelect="activeTab = $event; attFilter($event)" />
            <div class="row">
                <!-- <SponsorsProviderBuyerFilter
                    :filters="filters"
                    @updateFilter="updateFilter($event); getEconomicGroups()"
                    @empty="updateFilter($event); getEconomicGroups()"
                    
                /> -->
                <div class="ml-2">
                    <el-input 
                        @keyup.native.enter="getProvidersByGroupId" 
                        placeholder="Buscar" 
                        class="filter" 
                        :class="getPrimaryColor" 
                        v-model="filterSearch"
                        @clear="getProvidersByGroupId"
                        clearable
                    >
                        <button class="btn" slot="append" @click="getProvidersByGroupId">
                            <Search color="#A1A8B8" class="mx-0" />
                        </button>
                    </el-input>
                </div>
            </div>
        </div>
        <div class="col-12">
            <TableContainer
                :hasTable="providers.length > 0" 
                :isLoading="loading" 
                :pagination="pagination" 
                @updatePage="updatePage($event)"
                class="col-12  p-0"
                :totalPerPage="10"
            >
                <EconomicGroupProvidersLinked
                    :providers="providers"
                    @classificationChange="handleClassificationChange($event)"
                    @reload="reloadCreditLimit"
                    :showLimitAndActions="showLimitAndActions()"
                />
            </TableContainer>
            <NotFound class="pt-5" v-if="!loading && filterSearch.length > 0 && providers.length === 0" />
            <EmptyPage :button="false" title="Ainda não há cedentes nessa classificação!" v-else-if="!loading && filterSearch.length <= 0 && providers.length === 0">
                Por enquanto, não há cedentes nessa classificação.
            </EmptyPage>
        </div>
    </div>
    <FullLoading :color="getPrimaryColorHex.five" v-if="$store.state.user.loading"/>
</div>
</template>

<script>

// Libraries
// import { Money } from 'v-money'
import TableContainer from '@/components/tables/TableContainer'
import EconomicGroupProvidersLinked from '@/components/tables/EconomicGroupProvidersLinked'
// import Trash from '@/components/icons/Trash'

import Search from '@/components/icons/Search'
import NotFound from '@/components/emptyOrNotFound/NotFound'
import EmptyPage from '@/components/emptyOrNotFound/EmptyPage'

// Components
import ArrowDropdown from '@/components/icons/ArrowDropdown'
import FullLoading from '@/components/loading/FullLoading'
import getProvidersByGroupId from '@/api/getProvidersByGroupId'
import TabModelOfferProvider from '@/components/tabs/TabModelOfferProvider'

export default {
    components: {
        ArrowDropdown,
        TableContainer,
        FullLoading,
        EconomicGroupProvidersLinked,
        TabModelOfferProvider,
        Search,
        NotFound,
        EmptyPage,
    },
    data() {
        return {
            loading: false,
            page: 1,
            pagination: {},
            providers: [],
            economicGroup: {
            },
            activeTab: '0',
            filterSearch: '',
        }
    },
    // directives: {
    //     money: Money
    // },
    computed: {
        groupName() {
            return this.$store.state.group.groups.find(group => group.id == this.$route.params.groupId).name
        },
    },
    watch: {
        activeTab() {
            this.getProvidersByGroupId()
        }
    },
    methods: {
        async getProvidersByGroupId(){
            this.loading = true
            const tab = this.activeTab == '0' ? 'all' : this.activeTab == '1' ? 'defaultBuyer' : 'defaultProvider'
            const providers = await getProvidersByGroupId(this.$route.params.economicGroupId, { page: this.page, search: this.filterSearch, tab })
            console.log(providers);
            this.providers = providers.rows
            this.pagination = providers.pagination

            this.loading = false

        },
        showLimitAndActions() {
            if (this.economicGroup.economicGroupRule.modelOffers != 'manual') return true
            if (this.economicGroup.economicGroupRule.modelOffers == 'manual') return false
        },
        async updatePage(page){
            this.page = page
            await this.getProvidersByGroupId()
        },
        async handleClassificationChange() {
            console.log('aquiiii');
        },
        async reloadCreditLimit() {
            await this.getProvidersByGroupId()
        },
        attFilter(event) {
            this.activeTab = event
        },
    },
    async created() {
        this.economicGroup = this.$store.state.group.groups.find((economicGroup) => economicGroup.id == this.$route.params.economicGroupId)
        if (!this.economicGroup) this.$router.push('/404')
        await this.getProvidersByGroupId()

    },
    destroyed() {
    }

}
</script>

<style lang="scss">
.input-offer {
    width: 283px!important
}

.width-592 {
    width: 592px;
}

.width-150 {
    width: 150px;
}

.scroll-box {
    width: 592px;
    height: 264px;
    overflow-y: scroll;
}

.custon-textarea textarea {
    height: 131px!important;
}

</style>
